import { zahl } from '../formate';
import type { Kennzahlen } from '../typen';

function Karte({ titel, wert, hinweis }: { titel: string; wert: string; hinweis?: string }) {
  return (
    <div className="border border-[#DAD9D9] rounded px-4 py-3 min-w-[160px]">
      <div className="text-xs text-gray-600">{titel}</div>
      <div className="text-2xl font-bold text-[#1A1A1A]">{wert}</div>
      {hinweis && <div className="text-xs text-gray-500 mt-1">{hinweis}</div>}
    </div>
  );
}

export default function KennzahlenKarten({
  kennzahlen,
  namen,
  quellStatus,
}: {
  kennzahlen: Kennzahlen;
  /** Status, in dem nicht bestellte Aufträge bleiben (5.2, Testlauf 3.4). */
  quellStatus: number;
  /** Lieferanten-ID -> Anzeigename */
  namen: Record<string, string>;
}) {
  const positionen = Object.entries(kennzahlen.positionenJeLieferant)
    .map(([id, n]) => `${namen[id] ?? id}: ${zahl(n)}`)
    .join(' · ');
  return (
    <div className="flex flex-wrap gap-3">
      <Karte titel="Aufträge gesamt" wert={zahl(kennzahlen.auftraegeGesamt)} />
      <Karte titel="Bestellt" wert={zahl(kennzahlen.auftraegeBestellt)} />
      <Karte titel={`Bleibt in ${quellStatus}`} wert={zahl(kennzahlen.auftraegeBleiben)} />
      <Karte titel="Mit Lieferauftrag" wert={zahl(kennzahlen.auftraegeMitLieferauftrag)} hinweis="werden nicht bestellt" />
      <Karte
        titel="Positionen je Lieferant"
        wert={zahl(Object.values(kennzahlen.positionenJeLieferant).reduce((a, b) => a + b, 0))}
        hinweis={positionen || '—'}
      />
    </div>
  );
}
